import { renderReactModule, waitFor } from './helpers';

import Analytics from './modules/analytics';
import create from '@verndale/core';
import { sendPageViewBoxever } from './helpers/ZaiusBoxeverEvents';

const modules = [
  { name: 'cookiesBar', loader: () => import('./modules/cookiesBar') },
  { name: 'header', loader: () => import('./modules/header') },
  { name: 'breadcrumbs', loader: () => import('./modules/breadcrumbs') },
  { name: 'accordion', loader: () => import('./modules/accordion') },
  { name: 'homeVideo', loader: () => import('./modules/homeVideo') },
  { name: 'mosaicImageGallery', loader: () => import('./modules/mosaicImageGallery') },
  { name: 'horizontalTabs', loader: () => import('./modules/horizontalTabs') },
  { name: 'statisticsRow', loader: () => import('./modules/statisticsRow') },
  { name: 'insightsSlider', loader: () => import('./modules/insightsSlider') },
  { name: 'sliderCardsWithCta', loader: () => import('./modules/sliderCardsWithCta') },
  { name: 'featureSliderCardRow', loader: () => import('./modules/featureSliderCardRow') },
  { name: 'techPartners', loader: () => import('./modules/techPartners') },
  { name: 'peopleSlider', loader: () => import('./modules/peopleSlider') },
  {
    name: 'featuredCaseStudies',
    loader: () => import('./modules/featuredCaseStudies')
  },
  { name: 'imageText', loader: () => import('./modules/imageText') },
  {
    name: 'industryLeadersListing',
    loader: () => import('./modules/industryLeadersListing')
  },
  { name: 'officesListing', loader: () => import('./modules/officesListing') },
  { name: 'relatedNews', loader: () => import('./modules/relatedNews') },
  { name: 'eventsSlider', loader: () => import('./modules/eventsSlider') },
  {
    name: 'largeImageSlider',
    loader: () => import('./modules/largeImageSlider')
  },
  { name: 'newsResults', loader: () => import('./modules/newsResults') },
  { name: 'genericForm', loader: () => import('./modules/genericForm') },
  { name: 'mastheadForm', loader: () => import('./modules/mastheadForm') },
  { name: 'checkboxFilter', loader: () => import('./modules/checkboxFilter') },
  { name: 'eventDetails', loader: () => import('./modules/eventDetails') },
  {
    name: 'caseStudiesResults',
    loader: () => import('./modules/case-studies/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'insightResults',
    loader: () => import('./modules/insight-results/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'caseStudiesResultsListing',
    loader: () => import('./modules/case-studies-results-listing/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'featuredInsights',
    loader: () => import('./modules/featured-insights/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'marketplaceListing',
    loader: () => import('./modules/marketplace-listing/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'sliderHeroBanner',
    loader: () => import('./modules/sliderHeroBanner')
  },
  { name: 'socialGallery', loader: () => import('./modules/socialGallery') },
  {
    name: 'insightsSubscribe',
    loader: () => import('./modules/insightsSubscribe')
  },
  {
    name: 'scrollToContent',
    loader: () => import('./modules/scrollToContent')
  },
  { name: 'jobListing', loader: () => import('./modules/jobListing') },
  {
    name: 'InsightCardsGridV2',
    loader: () => import('./modules/InsightCardsGridV2')
  },
  { name: 'homeHeroV2', loader: () => import('./modules/homeHeroV2') },
  { name: 'videoContentV2', loader: () => import('./modules/videoContentV2') },
  {
    name: 'insightsSliderV2',
    loader: () => import('./modules/insightsSliderV2')
  },
  { name: 'vimeoV2', loader: () => import('./modules/vimeoV2') },
  {
    name: 'caseStudiesTabsV2',
    loader: () => import('./modules/caseStudiesTabsV2')
  },
  {
    name: 'caseStudiesTabItems',
    loader: () => import('./modules/caseStudiesTabItems.js')
  },
  {
    name: 'caseStudiesTabLogos',
    loader: () => import('./modules/caseStudiesTabLogos.js')
  },
  {
    name: 'technologiesSlider',
    loader: () => import('./modules/technologiesSlider')
  },
  {
    name: 'theOutcomeV2',
    loader: () => import('./modules/theOutcomeV2.js')
  },
  {
    name: 'aboutV2Info',
    loader: () => import('./modules/aboutV2Info.js')
  },
  {
    name: 'partnerSliderV2',
    loader: () => import('./modules/partnerSliderV2.js')
  },
  {
    name: 'expertiseScrollingV2',
    loader: () => import('./modules/expertiseScrollingV2')
  },
  {
    name: 'ourExpertiseGridV2',
    loader: () => import('./modules/ourExpertiseGridV2.js')
  },
  {
    name: 'breakToLines',
    loader: () => import('./modules/breakToLines.js')
  },
  {
    name: 'patternGrid',
    loader: () => import('./components/PatternGrid.js')
  },
  {
    name: 'splideSlider',
    loader: () => import('./modules/splideSlider.js')
  },
  {
    name: 'localVideo',
    loader: () => import('./modules/localVideo.js')
  },
  {
    name: 'insightCardSliderV2',
    loader: () => import('./modules/insightCardSliderV2.js')
  },
  {
    name: 'insightRelatedArticleV2',
    loader: () => import('./modules/insightRelatedArticleV2.js')
  },
  {
    name: 'insightV2CardCategory',
    loader: () => import('./modules/insightV2CardCategory.js')
  },
  {
    name: 'insightCategory',
    loader: () => import('./modules/insightCategory.js')
  },
  {
    name: 'animatedLargeButton',
    loader: () => import('./modules/animatedLargeButton.js')
  },
  {
    name: 'popularInsights',
    loader: () => import('./modules/popularInsights.js')
  },
  {
    name: 'ctaAnimation',
    loader: () => import('./modules/ctaAnimation.js')
  },
  {
    name: 'jobListingNew',
    loader: () => import('./modules/career-opportunities/jobListingNew.js')
  },
  {
    name: 'simplifiedHeader',
    loader: () => import('./modules/simplifiedHeader.js')
  },
  {
    name: 'masonryGrid',
    loader: () => import('./modules/masonryGrid.js')
  },
  {
    name: 'benefitCards',
    loader: () => import('./modules/benefitCards.js')
  },
  {
    name: 'latestWorkBlock',
    loader: () => import('./modules/latestWorkBlock.js')
  },
  {
    name: 'languageSelector',
    loader: () => import('./modules/languageSelector.js')
  }
];

document.addEventListener('DOMContentLoaded', () => {
  create(modules, 'js/modules');

  function trackGoal(a) {
    const dataAttributes = a.dataset;
    window.SCBeacon.trackGoal(dataAttributes.goal);
  }

  document.querySelectorAll('a[href]').forEach(a => {
    const { hostname: globalHostname } = window.location;
    const { hostname: anchorHostname } = a;

    if (globalHostname && anchorHostname) {
      if (globalHostname !== anchorHostname) {
        a.target = '_blank';
      }
    }

    if (a.dataset.module) {
      new Analytics(a);
    }
  });

  document
    .querySelectorAll('a[data-goal]')
    .forEach(a => a.addEventListener('click', a => trackGoal(a)));

  if (window.addthis) window.addthis.share();

  waitFor('Boxever', () => sendPageViewBoxever());
});
